export var SmsSendStatusType;
(function (SmsSendStatusType) {
    SmsSendStatusType["SUCCESS"] = "success";
    SmsSendStatusType["FAILURE"] = "failure";
    SmsSendStatusType["WAITING"] = "waiting";
})(SmsSendStatusType || (SmsSendStatusType = {}));
//# sourceMappingURL=SmsSendStatusType.js.map